const index = () => import('./Index');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/innovation/v2022/index',
      name: 'innovation_v2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/innovation/v2022/router.js